module.exports = __webpack_public_path__ + "media/images/home-banners/fall-1072821_1920-8937f433b51d7183ef9c94f08c892641.jpg";